var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayout',{staticClass:"page"},[_c('template',{slot:"header"},[_c('div',{staticClass:"d-flex m-3 mx-lg-0"},[_c('Breadcrumb',{attrs:{"list":_vm.breadcrumb}})],1),_c('MainNavbar')],1),_c('template',{slot:"main"},[_c('router-view')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }